import { Text } from '@vouched.id/vault';
import React from 'react';
export const LocationCaption = () => {
    return (React.createElement(Text, { style: { marginBottom: '15px' } }, "A location comparison between the ID Document's address and the submission device's IP address."));
};
